<template>
  <b-dropdown v-if='showMenu && menuIsNotEmpty'>
    <template #button-content>
      <i class="fa fa-ellipsis-v"></i>
    </template>
    <give-access-button
      v-if="!visitor.access && visibleCloseButton"
      :transport='transport'
      @change-access="$emit('change-transport-access', transport)"
    />
    <issue-pass-button
      v-if='visibleTransportIssuePassButton'
      title='Выдать пропуск'
      :is-issued='visitor.personal.isIssued'
      @issue-pass="$emit('issue-pass', transport)"
    />
    <issue-pass-button
      v-if='visibleTransportIssuePassPeriodButton'
      title='Выдать пропуска'
      :is-issued='visitor.personal.isIssued'
      @issue-pass="$emit('issue-pass', transport)"
    />
    <print-pass-button
      v-if='visibleTransportPrintPassButton'
      title='Распечатать пропуск'
      @give-pdf-pass="$emit('give-pdf-pass', isGivePassPeriod, printPermanentAsOne)"
    />
    <print-pass-button
      v-if="visibleTransportPrintPassPeriodButton"
      title='Распечатать пропуска'
      @give-pdf-pass="$emit('give-pdf-pass', isGivePassPeriod, printPermanentAsOne)"
    />
    <print-pass-button
      v-if='visibleTransportPrintPassPermanentAsOneButton'
      title='Выдать разовый пропуск'
      @give-pdf-pass="$emit('give-pdf-pass', isGivePassPeriod, printPermanentAsOne)"
    />
    <print-pass-button
      v-if='visibleTransportPrintPassPermanentButton'
      title='Выдать постоянный пропуск'
      @give-pdf-pass="$emit('give-pdf-pass', isGivePassPeriod, printPermanentAsOne)"
    />
  </b-dropdown>
</template>

<script>
import { ConfigMenuNames } from '@/common/enums/ConfigMenuNames';
import GiveAccessButton from './buttons/GiveAccessButton.vue';
import IssuePassButton from './buttons/IssuePassButton.vue';
import PrintPassButton from './buttons/PrintPassButton.vue';
export default {
  components: {
    GiveAccessButton,
    IssuePassButton,
    PrintPassButton
  },

  props: {
    cfgMenuVisitor: {
      type: Object
    },

    cfgMenuTransport: {
      type: Object
    },

    transport: {
      type: Object
    },

    visitor: {
      type: Object
    }
  },

  computed: {
    menuIsNotEmpty() {
      return (!this.visitor.access && this.visibleCloseButton) || this.visibleTransportIssuePassButton || this.visibleTransportIssuePassPeriodButton ||
        this.visibleTransportPrintPassButton || this.visibleTransportPrintPassPeriodButton || this.visibleTransportPrintPassPermanentAsOneButton || this.visibleTransportPrintPassPermanentButton
    },

    isGivePassPeriod() {
      return !!this.cfgMenuVisitor[ConfigMenuNames.GIVE_PASS_PERIOD]
    },

    printPermanentAsOne() {
      return Boolean(this.cfgMenuVisitor[ConfigMenuNames.GIVE_PASS_ONE])
    },

    visibleCloseButton() {
      return Boolean(this.user && this.cfgMenuVisitor.give_access_visitor)
    },

    showMenu() {
      return ((
        Array.isArray(this.cfgMenuTransport) === false && (
          this.transport.inScud === 0 || (
            this.cfgMenuTransport[ConfigMenuNames.GIVE_PASS] ||
            this.cfgMenuTransport[ConfigMenuNames.SEND_TO_SOLVO]
          )
        )) || this.visibleCloseButton
      )
    },

    visibleTransportIssuePassButton() {
      return Boolean(
        this.visitor.access === 0 && (
          this.cfgMenuTransport[ConfigMenuNames.GIVE_PASS] ||
          this.cfgMenuTransport[ConfigMenuNames.GIVE_PASS_ONE] ||
          this.cfgMenuTransport[ConfigMenuNames.GIVE_PASS_PERMANENT]) &&
        !this.cfgMenuTransport[ConfigMenuNames.GIVE_PASS_PERIOD] &&
        !this.transport.isIssued
      )
    },

    visibleTransportIssuePassPeriodButton() {
      return Boolean(
        this.visitor.access === 0 &&
        !this.cfgMenuTransport[ConfigMenuNames.GIVE_PASS] &&
        this.cfgMenuTransport[ConfigMenuNames.GIVE_PASS_PERIOD] &&
        !this.transport.isIssued
      )
    },

    visibleTransportPrintPassButton() {
      return Boolean(
        this.visitor.access === 0 &&
        this.cfgMenuTransport[ConfigMenuNames.GIVE_PASS] &&
        !this.cfgMenuTransport[ConfigMenuNames.GIVE_PASS_PERIOD] &&
        !this.cfgMenuTransport[ConfigMenuNames.GIVE_PASS_ONE] &&
        !this.cfgMenuTransport[ConfigMenuNames.GIVE_PASS_PERMANENT] &&
        this.transport.isIssued
      )
    },

    visibleTransportPrintPassPeriodButton() {
      return Boolean(
        this.visitor.access === 0 &&
        this.cfgMenuTransport[ConfigMenuNames.GIVE_PASS_PERIOD] &&
        !this.cfgMenuTransport[ConfigMenuNames.GIVE_PASS] &&
        !this.cfgMenuTransport[ConfigMenuNames.GIVE_PASS_ONE] &&
        !this.cfgMenuTransport[ConfigMenuNames.GIVE_PASS_PERMANENT] &&
        this.transport.isIssued
      )
    },

    visibleTransportPrintPassPermanentAsOneButton() {
      return Boolean(
        this.visitor.access === 0 &&
        this.cfgMenuTransport[ConfigMenuNames.GIVE_PASS_ONE] &&
        !this.cfgMenuTransport[ConfigMenuNames.GIVE_PASS] &&
        !this.cfgMenuTransport[ConfigMenuNames.GIVE_PASS_PERIOD] &&
        this.transport.isIssued
      )
    },

    visibleTransportPrintPassPermanentButton() {
      return Boolean(
        this.visitor.access === 0 &&
        this.cfgMenuTransport[ConfigMenuNames.GIVE_PASS_PERMANENT] &&
        !this.cfgMenuTransport[ConfigMenuNames.GIVE_PASS] &&
        !this.cfgMenuTransport[ConfigMenuNames.GIVE_PASS_PERIOD] &&
        this.transport.isIssued
      )
    }
  }
}
</script>
